import { save, openWhatsapp, getMeta, isDesktop, getMessage, isSendMessageToWhatsappEnabled } from '../store.js';
import axios from 'axios';

(function ($) {
    $(document).ready(function () {

        $(document).on('gform_confirmation_loaded', async function (event, formId) {
            const rest = await axios.get(formychat_vars.ajax_url + '?action=formychat_get_gf_entry&id=' + formId + '&nonce=' + formychat_vars.nonce);
            const settings = rest.data.data.formychat || {};

            const widget = document.querySelector('[data-whatsapp]');

            let data = {
                form: 'gravity',
                form_id: formId,
                field: settings.values,
                meta: getMeta.value,
                widget_id: widget ? widget.dataset.widget : null,
            }


            if (widget ) {
                // Inside widget.
                const widgetId = widget.dataset.widget;
                if (!widgetId) return;

                const widgetObject = formychat_vars.data.widgets.find(widget => widget.id == widgetId);
                if ( !widgetObject ) return;
                
                try {
                    const targetOrigin = (typeof formychat_vars !== 'undefined' && formychat_vars?.site?.url)
                        ? new URL(formychat_vars.site.url).origin
                        : '*';
                    window.parent.postMessage({formychat_submitted: JSON.parse(JSON.stringify(data))}, targetOrigin);
                } catch (err) {
                }
                const whatsappConfig = { ...(widgetObject.config.whatsapp || {}), widget_id: widgetId };
                const { new_tab, web_version, gravity_message_template, destination_type, group_invite_code } = whatsappConfig;
                const whatsappNumber = destination_type === 'group' && group_invite_code ? group_invite_code : widget.dataset.whatsapp;
                const message = getMessage(gravity_message_template, settings.values);

                save(data, whatsappNumber, message, isDesktop() && web_version == 1, new_tab == 1);
                if (isSendMessageToWhatsappEnabled(whatsappConfig)) {
                    openWhatsapp(whatsappNumber, message, isDesktop() && web_version == 1, new_tab == 1, whatsappConfig);
                }

            } else {
                // Outside widget.
                
                
                // if ( ! settings.status ) return;
                // let message = getMessage(settings.message, inputs);
                // console.log('message', message);
                // return;
                
                // save(data, settings.whatsapp_number, message, isDesktop(), 1 == settings.new_tab);
                // openWhatsapp(settings.whatsapp_number, message, isDesktop(), 1 == settings.new_tab);
            }
        });


        window.gform_formychat = function (form, entries = {}, settings) {
            
            // Object to store label-value pairs
            let values = {};
        
            // Loop through fields in the form
            form.fields && form.fields.forEach(field => {
                let label = field.label; // Get the label of the field
                let value;
        
                // Check if the field has multiple inputs (e.g., name fields with prefix, first, last, etc.)
                if (field.inputs && Array.isArray(field.inputs)) {
                    // Concatenate values for multi-input fields
                    value = field.inputs.map(input => {
                        const inputValue = entries[input.id] || ''; // Get the entry value for each sub-field
                        return inputValue.trim(); // Trim spaces to avoid unnecessary gaps
                    }).filter(v => v).join(' '); // Join non-empty values with a space
                } else {
                    // For single-input fields, get the value directly
                    value = entries[field.id] || '';
                }
        
                // Add the label-value pair to the values object
                if (label && value) {
                    values[label] = value;
                }
            });
        
            // Save inputs.
            let data = {
                form: 'gravity',
                form_id: form.id,
                field: values,
                meta: getMeta.value,
                widget_id: null,
            }

            let message = getMessage(settings.message, values);
            // console.log('message', data, settings.whatsapp_number, message, isDesktop(), 1 == settings.new_tab);
        
            const to = settings.destination_type === 'group' && settings.group_invite_code ? settings.group_invite_code : settings.whatsapp_number;
            save(data, to, message, isDesktop(), 1 == settings.new_tab);
            openWhatsapp(to, message, isDesktop(), 1 == settings.new_tab, settings);
        };

        // Trigger new custom event formychat_gravity_forms_loaded
        const event = new CustomEvent('formychat_gravity_forms_loaded', {
            detail: { 
                formychat_gravity_forms_loaded: true
            }
        });

        document.dispatchEvent(event);
        
        // Legacy support for old event name (deprecated)
        const legacyEvent = new CustomEvent('formychat_gf_loaded', {
            detail: {
                formychat_gf_loaded: true
            }
        });
        document.dispatchEvent(legacyEvent);

    });

})(jQuery)